import {useState} from 'react';

import useAuth from '../../../hooks/useAuth';
// import Btn_dj  from '../../../components/Btn_dj'
import {ErroAviso} from  '../../../components/Erro'

export default function Logout() {

  const { logoutUser, loading} = useAuth(); //
  //logoutUser();
  const [modo, setModo ] = useState("home");

  const modos = {
    home:{
        titulo:   "Sair?",
        aviso:'Tem certeza que deseja sair?',
        legenda:  "Todo o progresso não será perdido",
        btn_texto:"Sim, desejo sair",
        btn_to:"#saindo",
        btn_OnClick:()=>sair({logoutUser,loading, modo, setModo})
    },
    confirmado:{
      titulo:   "Saiu",
      aviso:'Você acaba de sair da sua conta',
      legenda:  "Tudo bem fechar a página ou voltar ao início da plataforma",
      btn_texto:"Clique aqui para ir ao início da plataforma",
      btn_to:   "/inicio",
    }
  }

  const textosProps = modos[modo];

  return ( <>
    <ErroAviso
      titulo  = {textosProps.titulo}
      aviso  = {textosProps.aviso}
      description  = {textosProps.legenda}
      btn_text  = {textosProps.btn_texto}
      btn_to  = {textosProps.btn_to}
      btn_OnClick  = {textosProps.btn_OnClick}
    />
  </> )
};

async function sair({logoutUser,loading, modo, setModo}){
    let res = {}
    if (modo==="home"){
      res = await logoutUser()
    }
    if (!loading){
      setModo("confirmado")
      console.log(res)
    }

}
